import url from './url';



export default url(({ configurationId = ':configurationId', configurationName = ':configurationName' }) => `/configurations/${configurationId}/${configurationName}/mixin/create`);
